/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const CreateAccountType = {
  Individual: "individual",
  Business: "business",
} as const;
export type CreateAccountType = ClosedEnum<typeof CreateAccountType>;

/** @internal */
export const CreateAccountType$inboundSchema: z.ZodNativeEnum<
  typeof CreateAccountType
> = z.nativeEnum(CreateAccountType);
/** @internal */
export const CreateAccountType$outboundSchema: z.ZodNativeEnum<
  typeof CreateAccountType
> = CreateAccountType$inboundSchema;
